import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import tickImage from "../../assets/images/tick.png";
import SecondaryButton from "../../common/secondaryButton";
import SubmitModal from "../liveTest/submitModal";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../Redux/common/actions";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import examActions from "../../Redux/exam/actions";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import {
  DecryptObjectFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import useFetchQuestion from "../../hooks/useFetchQuestion";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../../utils/auditLog";
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);

export default function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { questionsAndOptions, projectDetails, heartBeat } = useSelector(
    (state) => state.examReducer
  );
  const [questionNumber, setQuestionNumber] = useState([]);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [visitedQuestions, setVisitedQuestions] = useState(new Set());
  const isVenue = sessionStorage.getItem("venue") ?? false;
  const apiUrl = sessionStorage.getItem("apiUrl");
  const [searchParams] = useSearchParams();
  const encryptedParams = searchParams.get("qNo");
  let isMock = projectDetails?.mockMode;

  let decryptedParams = {};
  if (encryptedParams) {
    try {
      decryptedParams = DecryptObjectFunction(encryptedParams);
    } catch (error) {
      console.error("Error decrypting parameters:", error);
      decryptedParams = {};
    }
  } else {
    console.warn("No query parameter 'qNo' found.");
  }

  const [data, setData] = useState({});

  let isAutologout = candidateTokenDetails?.configuration?.autoLogout;
  const isLateLoginAllowed =
    candidateTokenDetails?.configuration?.lateLoginAllowed;
  const isForceLogout = candidateTokenDetails?.configuration?.forceLogout;

  const examEndTime = localStorage.getItem("examEndTime");
  const examEndDate = new Date(examEndTime);
  examEndDate.setTime(examEndDate.getTime() + (5 * 60 + 30) * 60 * 1000);
  const updatedExamEndTime = examEndDate.toISOString();
  const now = new Date(heartBeat?.data);
  const isSection = Object.values(
    questionsAndOptions?.questionsList || {}
  ).every((res) => "section" in res);
  const isStartExamBetweenSpecifiedTime =
    candidateTokenDetails?.configuration?.startExamBetweenSpecifiedTime;
  const isMultidayExamWithSection =
    isSection && isStartExamBetweenSpecifiedTime;
  const isMaximumLoginAttempts =
    candidateTokenDetails?.configuration?.maximumLoginAttempts === null;

  // const endTime = new Date(
  //   // (isLateLoginAllowed && isMaximumLoginAttempts) ||
  //   // (isMultidayExamWithSection && isMaximumLoginAttempts)
  //   //   ? candidateTokenDetails?.configuration?.endTime
  //   //   :
  //   isForceLogout
  //   ? candidateTokenDetails?.configuration?.endTime
  //   : updatedExamEndTime ?? candidateTokenDetails?.configuration?.endTime
  // );

  const endTime = new Date(
    isForceLogout
      ? candidateTokenDetails?.configuration?.endTime
      : updatedExamEndTime ?? candidateTokenDetails?.configuration?.endTime
  );

  const isExamEnded = now > endTime;

  useEffect(() => {
    const numArray = Array.from({ length: 70 }, (_, i) => i + 1);
    setQuestionNumber(numArray);
  }, []);

  useEffect(() => {
    const storedVisited = sessionStorage.getItem("visitedQuestions");
    if (storedVisited) {
      setVisitedQuestions(new Set(JSON.parse(storedVisited)));
    }
  }, [visitedQuestions]);

  const handleSubmit = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: "confirm", method: "S", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected in Summary Submit",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  const statusConfigs = [
    {
      key: "answered",
      label: "Answered",
      style: {
        width: "22.82px",
        height: "22.82px",
        background: "rgba(84, 179, 55, 1)",
        clipPath:
          "polygon(25% 0%, 75% 0%, 100% 50%, 100% 100%, 0 100%, 0% 50%)",
      },
    },
    {
      key: "unanswered",
      label: "Unanswered",
      style: {
        width: "22.82px",
        height: "22.82px",
        background: "rgba(234, 104, 58, 1)",
        clipPath: "polygon(0 0, 100% 0, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
      },
    },
    {
      key: "not_viewed",
      label: "Not Viewed",
      style: {
        width: "22.82px",
        height: "22.82px",
        background:
          "linear-gradient(45deg, rgba(240, 239, 240, 1), rgba(201, 200, 201, 1))",
      },
    },
    {
      key: "marked",
      label: "Marked for Review",
      style: {
        width: "22.82px",
        height: "22.82px",
        background: "rgba(130, 91, 172, 1)",
        borderRadius: "50%",
      },
    },
    {
      key: "answered_and_marked",
      label: "Answered & Marked for Review",
      style: {
        width: "22.82px",
        height: "22.82px",
        background: "rgba(130, 91, 172, 1)",
        borderRadius: "50%",
        position: "relative",
      },
    },
  ];

  const getStatusCount = (status) => {
    return Object.values(questionsAndOptions?.questionsList || {}).filter(
      (q) => {
        // const questionNumber = Object.keys(
        //   questionsAndOptions.questionsList
        // ).find((key) => questionsAndOptions.questionsList[key] === q);

        // if (status === "not-viewed") {
        //   return (
        //     !visitedQuestions.has(questionNumber) &&
        //     (q.status.toLowerCase() === "unanswered" || !q.status)
        //   );
        // }

        // if (status === "unanswered") {
        //   return (
        //     visitedQuestions.has(questionNumber) &&
        //     q.status.toLowerCase() === "unanswered"
        //   );
        // }

        return q.status.toLowerCase() === status;
      }
    ).length;
  };

  // useEffect

  const getQuestionStyle = (
    questionStatus,
    isCurrentQuestion,
    questionNumber,
    visitedQuestions
  ) => {
    if (isCurrentQuestion) {
      return {
        background: "#808080",
      };
    }

    if (
      !visitedQuestions.has(questionNumber.toString()) &&
      (questionStatus?.toLowerCase() === "unanswered" || !questionStatus)
    ) {
      return {
        background:
          "linear-gradient(45deg, rgba(240, 239, 240, 1), rgba(201, 200, 201, 1))",
      };
    }

    switch (questionStatus?.toLowerCase()) {
      case "answered":
        return {
          background: "rgba(84, 179, 55, 1)",
          clipPath:
            "polygon(25% 0%, 75% 0%, 100% 50%, 100% 100%, 0 100%, 0% 50%)",
        };
      case "unanswered":
        return {
          background: "rgba(234, 104, 58, 1)",
          clipPath:
            "polygon(0 0, 100% 0, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
        };
      case "marked":
        return {
          background: "rgba(130, 91, 172, 1)",
          borderRadius: "50%",
        };
      case "answered_and_marked":
        return {
          background: "rgba(130, 91, 172, 1)",
          borderRadius: "50%",
        };
      default:
        return {
          background:
            "linear-gradient(45deg, rgba(240, 239, 240, 1), rgba(201, 200, 201, 1))",
        };
    }
  };

  useEffect(() => {
    if (questionsAndOptions?.questionsList) {
      const groupedData = Object.entries(
        questionsAndOptions.questionsList
      ).reduce((acc, [key, value]) => {
        if (!acc[value.section]) {
          acc[value.section] = [];
        }
        acc[value.section].push({
          question_number: key,
          status: value.status.toLowerCase(),
        });
        return acc;
      }, {});

      setData(groupedData);
    }
  }, [questionsAndOptions?.questionsList]);

  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: `${Cookies.get("test_engine_project")}`,
        },
      },
    });
  }, []);

  const handleResumeExam = async () => {
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Resume Exam",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    const formData = {
      imageSize: `${decryptedParams?.img}`,
      action: "next",
      currentSrNo: decryptedParams?.SrNo,
      nextSrNo: decryptedParams?.SrNo,
      selectedAnswer: questionsAndOptions?.questionData?.selectedAnswer || 0,
      language: `${decryptedParams?.lang}`,
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    const queryParams = {
      SrNo: decryptedParams?.SrNo,
      lang: `${decryptedParams?.lang}`,
      img: `${decryptedParams?.img}`,
    };
    const encryptedParams = EncryptObjectFunction(queryParams);
    dispatch({
      type: examActions.GET_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: (path) => navigate(`${path}?qNo=${encryptedParams}`),
        mockMode: projectDetails?.mockMode,
        formData: formData,
        summary: true,
      },
    });
  };

  const [countdown, setCountdown] = useState(null);
  const [countdownStarted, setCountdownStarted] = useState(false);

  useEffect(() => {
    const checkTimeAndStartCountdown = () => {
      if (isExamEnded && !countdownStarted) {
        setCountdownStarted(true);
        setCountdown(60);
      }
    };

    const interval = setInterval(checkTimeAndStartCountdown, 1000);
    return () => clearInterval(interval);
  }, [countdownStarted, isExamEnded]);

  useEffect(() => {
    if (countdown === null || countdown <= 0) {
      if (countdown === 0) {
        if (isVenue) {
          Cookies.remove("candidate_details");
          Cookies.remove("candidate_exam_details");
          Cookies.remove("test_engine_token");
          sessionStorage.removeItem("examEnded");
          sessionStorage.removeItem("lastUpdatedIndex");
          sessionStorage.removeItem("isEarlyMovedSection");
          navigate(`/login?apiUrl=${apiUrl}`);
        } else {
          Cookies.remove("test_engine_token");
          Cookies.remove("candidate_details");
          Cookies.remove("candidate_exam_details");
          sessionStorage.removeItem("examEnded");
          sessionStorage.removeItem("lastUpdatedIndex");
          sessionStorage.removeItem("isEarlyMovedSection");
          navigate(`/${Cookies.get("test_engine_project")}/login`);
        }
      }
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  useFetchQuestion({
    currentSrNo: decryptedParams?.SrNo,
    language: decryptedParams?.lang,
    imageSize: decryptedParams?.img,
    questionsAndOptions,
    decryptedParams,
    projectDetails,
    handleEncodeJson,
    EncryptObjectFunction,
    isNavigate: false,
  });

  return (
    <>
      <Grid container sx={{ backgroundColor: "#fff", minHeight: "88vh" }}>
        <Grid item md={2.5} p={2} sx={{ position: "relative" }} pt={5.5}>
          <Grid
            sx={{
              backgroundColor: "rgba(240, 240, 251, 1)",
              height: "32px",
              borderRadius: "8px",
            }}
            p={1}
          >
            <Typography
              sx={{
                color: "rgba(63, 65, 209, 1)",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              Summary
            </Typography>
          </Grid>
          <Grid
            container
            sx={{ display: "flex", flexDirection: "column", rowGap: "12px" }}
            p={2}
          >
            {statusConfigs.map((config) => (
              <Box
                key={config.key}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  transform: "translateZ(0)",
                  backfaceVisibility: "hidden",
                  perspective: "1000px",
                }}
              >
                <Typography sx={{ fontSize: "14px" }}>
                  {config.label}
                </Typography>
                <Box
                  sx={{
                    ...config.style,
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                  }}
                >
                  {getStatusCount(config.key)}
                  {config.key === "answered_and_marked" && (
                    <Box
                      component="img"
                      alt="check"
                      src={tickImage}
                      sx={{
                        position: "absolute",
                        bottom: -1,
                        right: -4,
                        height: "13px",
                        width: "auto",
                      }}
                    />
                  )}
                </Box>
              </Box>
            ))}
          </Grid>

          <Grid
            p={1}
            sx={{ position: "absolute", bottom: 0, width: "100%" }}
            pb={2}
          >
            {" "}
            <Box pb={2}>
              {!isAutologout && !isExamEnded && (
                <SecondaryButton
                  onClick={handleResumeExam}
                  borderRadius="138px"
                  height="38px"
                  width="89%"
                >
                  Resume exam
                </SecondaryButton>
              )}
            </Box>
            <Button
              size="small"
              variant="contained"
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                padding: "4px",
                width: "89%",
                backgroundColor: "#E598AC",
                color: "#000",
                borderRadius: "138px",
                height: "38px",
                "&:hover": {
                  backgroundColor: "#E598AC",
                },
                cursor: "default",
              }}
              onClick={handleSubmit}
            >
              {isMock ? "Submit Exam" : "Submit"}
            </Button>
          </Grid>
        </Grid>
        <Grid item md={9.4} sx={{ background: "#fff" }} p={2}>
          <Typography
            sx={{
              fontSize: "20px",
              color: "rgba(63, 65, 209, 1)",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Exam Summary
          </Typography>
          {Object.entries(data).map(([section, questions], index) => {
            return (
              <Box key={section} sx={{ mb: 2 }}>
                {isSection && (
                  <Box
                    p={1}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                      backgroundColor: "rgba(240, 240, 251, 1)",
                      height: "32px",
                      borderRadius: "8px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(63, 65, 209, 1)",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      {section}
                    </Typography>
                    {/* <Typography variant="body2">
                      {index < currentSectionIndex && (
                        <p>Time's up for this section!</p>
                      )}
                      {index === currentSectionIndex && (
                        <p>Time Remaining : {formatTime(remainingTime)}</p>
                      )}
                      {index > currentSectionIndex && (
                        <p>This section is locked</p>
                      )}
                    </Typography> */}
                  </Box>
                )}
                <Grid
                // sx={{
                //   height: "290px",
                //   overflowY: "scroll",
                //   paddingRight: "8px",
                //   "&::-webkit-scrollbar": {
                //     width: "8px",
                //   },
                //   "&::-webkit-scrollbar-track": {
                //     background: "#e0e0e0",
                //     borderRadius: "10px",
                //   },
                //   "&::-webkit-scrollbar-thumb": {
                //     background: "blue",
                //     borderRadius: "10px",
                //     border: "2px solid #e0e0e0",
                //     height: "10px",
                //     paddingBottom: "12px",
                //   },
                //   "&::-webkit-scrollbar-thumb:hover": {
                //     background: "darkblue",
                //   },
                // }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(25, 1fr)",
                      gap: 1,
                    }}
                  >
                    {questions?.map((obj) => {
                      // const isCurrentQuestion =
                      //   currentSrNo === parseInt(obj.question_number);

                      const baseStyles = getQuestionStyle(
                        obj.status,
                        null,
                        obj.question_number,
                        visitedQuestions
                      );

                      return (
                        <Box
                          key={obj.question_number}
                          // onClick={() => {
                          //   if (!isSection) {
                          //     handleQuestionNavigation(obj);
                          //     handleAuditLog("", "", obj.question_number);
                          //   } else if (index === currentSectionIndex) {
                          //     handleQuestionNavigation(obj);
                          //     handleAuditLog("", "", obj.question_number);
                          //   }
                          // }}
                          sx={{
                            ...baseStyles,
                            aspectRatio: "1/1",
                            width: "25px",
                            height: "25px",
                            top: "4.59px",
                            left: "4.59px",
                            gap: "0px",
                            color: "#000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            // cursor: isSection
                            //   ? index === currentSectionIndex
                            //     ? "pointer"
                            //     : "not-allowed"
                            //   : "pointer",
                            // opacity: isSection
                            //   ? index === currentSectionIndex
                            //     ? 1
                            //     : 0.5
                            //   : 1,
                            position: "relative",
                            // "&:hover": {
                            //   transform: isCurrentQuestion
                            //     ? "none"
                            //     : "scale(1.05)",
                            //   transition: "transform 0.2s ease-in-out",
                            // },
                          }}
                        >
                          {obj.question_number}
                          {obj.status === "answered_and_marked" &&
                             (
                              <Box
                                component="img"
                                alt="check"
                                src={tickImage}
                                sx={{
                                  position: "absolute",
                                  bottom: -1,
                                  right: -4,
                                  height: "13px",
                                  width: "auto",
                                }}
                              />
                            )}
                        </Box>
                      );
                    })}
                  </Box>
                </Grid>
              </Box>
            );
          })}
        </Grid>
      </Grid>
      <SubmitModal type={"confirm"} heartBeat={heartBeat} />
    </>
  );
}
